import Loading from 'components/Loading';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { cadastroContribuinte, visualizarContribuinte } from 'routes/paths';
import { duckDadosCadastrais, duckDadosCadastraisDetalhar } from 'store/ducks/dadosCadastrais';
import { duckInputDadosCadastrais } from 'store/ducks/inputs';
import { fetchGetDadosCadastrais } from 'store/fetchActions/fetchDadosCadastrais';
import { formatterDadosCadastraisBackToFront } from 'utils/formatter/dadosCadastrais';

const PageDadosCadastrais = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);

  React.useEffect(() => {
    dispatch(fetchGetDadosCadastrais())
      .then(pessoas => {
        dispatch(duckInputDadosCadastrais(null));
        // Caso pessoa seja física,
        if (
          (user?.document_type === 'CPF' && pessoas?.length > 0) ||
          (user?.document_type === 'CNPJ' && pessoas?.length === 2)
        ) {
          dispatch(duckDadosCadastraisDetalhar(formatterDadosCadastraisBackToFront(pessoas)));
          history.push(visualizarContribuinte);
          return;
        }
        dispatch(duckDadosCadastrais(pessoas));
        history.push(cadastroContribuinte);
      })
      .catch(() => {
        history.goBack();
      });
  }, [history, dispatch, user]);

  return <Loading />;
};

export default PageDadosCadastrais;
